import { createSession, faro } from '@grafana/faro-react';

export const setGrafanaSession = (sessionProps: Record<string, string>) => {
  faro.api?.setSession(
    createSession({
      ...sessionProps,
    }),
  );
};
